import PageHero from '@/components/site/PageHero';
import SectionHeading from '@/components/site/SectionHeading';
import CtaBand from '@/components/site/CtaBand';
import CheckList from '@/components/sections/CheckList';
import ServiceDetailGrid from '@/components/sections/ServiceDetailGrid';
import Reveal from '@/components/ui/Reveal';
import { usePage } from '@site/content';
import { useServices } from '@api/public';

export default function Services() {
  const { hero, fire, security, audit, process } = usePage('services');
  const fireServices = useServices('fire');
  const securityServices = useServices('security');

  return (
    <>
      <PageHero {...hero} />

      <section id="fire" className="scroll-mt-28 py-16 sm:py-24">
        <div className="site-container">
          <SectionHeading eyebrow={fire.eyebrow} title={fire.title} text={fire.text} />
          <div className="mt-14">
            <ServiceDetailGrid services={fireServices} />
          </div>
        </div>
      </section>

      <section id="security" className="scroll-mt-28 bg-ink-950 py-16 text-white sm:py-24">
        <div className="site-container">
          <div className="grid items-center gap-10 lg:grid-cols-2">
            <SectionHeading eyebrow={security.eyebrow} title={security.title} text={security.text} tone="dark" />
            <img src={security.image} alt={security.imageAlt} loading="lazy" className="aspect-[16/9] w-full rounded-[2rem] object-cover" />
          </div>
          <div className="mt-14">
            <ServiceDetailGrid services={securityServices} />
          </div>
        </div>
      </section>

      <section id="audit" className="scroll-mt-28 py-16 sm:py-24">
        <div className="site-container grid items-start gap-12 lg:grid-cols-[1.3fr_1fr]">
          <div>
            <SectionHeading eyebrow={audit.eyebrow} title={audit.title} text={audit.text} />
            <div className="mt-8">
              <CheckList items={audit.items} />
            </div>
          </div>
          <Reveal>
            <img src={audit.image} alt={audit.imageAlt} loading="lazy" className="aspect-[4/3] w-full rounded-[2rem] object-cover lg:aspect-[4/5]" />
          </Reveal>
        </div>
      </section>

      <section className="bg-ink-50 py-16 sm:py-24">
        <div className="site-container">
          <SectionHeading eyebrow={process.eyebrow} title={process.title} align="center" />
          <ol className="relative mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {process.steps.map((step, i) => (
              <Reveal key={step.title} delay={(i % 3) * 0.06} as="li">
                <div className="relative h-full rounded-2xl border border-[var(--app-border)] bg-white p-6">
                  <span className="absolute right-5 top-4 font-display text-6xl font-extrabold leading-none text-primary-100">{String(i + 1).padStart(2, '0')}</span>
                  <span className="block h-1 w-10 rounded-full bg-flame-x" aria-hidden="true" />
                  <h3 className="mt-5 text-2xl text-ink-950">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-600">{step.text}</p>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
